import { render } from "./ChiffreAffaires.vue?vue&type=template&id=48b1aec7"
import script from "./ChiffreAffaires.vue?vue&type=script&lang=js"
export * from "./ChiffreAffaires.vue?vue&type=script&lang=js"

import "./ChiffreAffaires.vue?vue&type=style&index=0&id=48b1aec7&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__